import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxBadgeComponent,
  OnyxIconComponent,
  OnyxLinkComponent,
  OnyxPhonePipe,
} from '@onyx/angular';
import { BaseHelper } from '../../../management-panel/bases/common/helpers/base.helper';
import type { Driver } from '../../common/interfaces/driver';
import { DriverStatus } from '../../common/interfaces/driver-status';

@Component({
  selector: 'app-driver-modal-header-description',
  imports: [
    OnyxIconComponent,
    OnyxPhonePipe,
    TranslatePipe,
    OnyxBadgeComponent,
    OnyxLinkComponent,
  ],
  templateUrl: './driver-modal-header-description.component.html',
  styleUrl: './driver-modal-header-description.component.scss',
})
export class DriverModalHeaderDescriptionComponent {
  protected readonly baseHelper = inject(BaseHelper);

  public readonly driver = input.required<Driver>();

  private readonly I18N = 'drivers.driverModal';

  protected status = computed(() => {
    switch (this.driver().status.status) {
      case DriverStatus.FREE:
      case DriverStatus.DELEGATION:
      case DriverStatus.UNASSIGNED:
        return {
          name: `${this.I18N}.active`,
          badgeColor: 'light-green',
        } as const;

      case DriverStatus.UNAVAILABLE:
        return {
          name: 'labels.unavailable',
          badgeColor: 'light-red',
        } as const;

      default:
        return {
          name: `${this.I18N}.archived`,
          badgeColor: 'light-gray',
        } as const;
    }
  });
}
